import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
var _callback = /*#__PURE__*/_classPrivateFieldLooseKey("callback");
var _id = /*#__PURE__*/_classPrivateFieldLooseKey("id");
var _tags = /*#__PURE__*/_classPrivateFieldLooseKey("tags");
// Types

// Types

export default class Metrics {
  constructor({
    callback,
    id,
    tags
  }) {
    Object.defineProperty(this, _callback, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _id, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _tags, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _callback)[_callback] = callback;
    _classPrivateFieldLooseBase(this, _id)[_id] = id;
    _classPrivateFieldLooseBase(this, _tags)[_tags] = Object.keys(tags || {}).length ? tags : undefined;
  }
  get id() {
    return _classPrivateFieldLooseBase(this, _id)[_id];
  }
  send() {
    var _classPrivateFieldLoo, _classPrivateFieldLoo2;
    (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _callback))[_callback]) == null || _classPrivateFieldLoo.call(_classPrivateFieldLoo2, this.serialize());
    this.reset();
  }
  serialize() {
    const serialized = {
      metric: {
        id: _classPrivateFieldLooseBase(this, _id)[_id]
      }
    };
    if (_classPrivateFieldLooseBase(this, _tags)[_tags]) {
      serialized.metric.tags = _classPrivateFieldLooseBase(this, _tags)[_tags];
    }
    return serialized;
  }
  get tags() {
    return _classPrivateFieldLooseBase(this, _tags)[_tags];
  }
}
//# sourceMappingURL=Metrics.js.map